<template>
<v-container fluid>
  <v-toolbar floating flat color="transparent">

    <img src="@/assets/logo.svg" width="36" height="36" class="mr-4" />

    <v-toolbar-title>{{ $t('app_name') }}</v-toolbar-title>

    <v-spacer></v-spacer>

    <UserAvatarMenu></UserAvatarMenu>

  </v-toolbar>
</v-container>
</template>

<script>
import UserAvatarMenu from '@/components/auth/UserAvatarMenu'
export default {
  name: 'PanelBar',
  components: {
    UserAvatarMenu
  }
}
</script>
